export const en = {
  impactPage: {
    helmet: {
      title: 'Impact',
    },
    header: {
      title: 'Impact at {{companyName}}',
      subtitle: "Your company's volunteering activity",
    },
    stats: {
      opportunities: {
        title: 'Total Events Completed',
        chartLabel: 'Events Completed',
      },
      hours: {
        title: 'Total Volunteer Hours',
        chartLabel: 'Volunteer Hours',
      },
      signups: {
        title: 'Total Volunteer Sign Ups',
        chartLabel: 'Volunteer Sign Ups',
      },
      attendance: {
        title: 'Sign Up vs Attendance Rates',
        chartLabel: 'Attendance Rate',
      },
    },
    tables: {
      columns: {
        name: 'Name',
        volunteerHours: 'Volunteer Hours',
        opportunitiesCompleted: 'Events Completed',
        date: 'Date',
        attendance: 'Attendance',
      },
      cards: {
        locations: 'Top Locations',
        departments: 'Top Departments',
        causes: 'Top Causes',
        nonprofits: 'Top Nonprofits',
        activeEmployees: 'Most Active Employees',
        recentActivity: 'Most Recent Activity',
        initiatives: 'Initiatives',
      },
    },
    filters: {
      buttons: {
        clear: 'Clear',
      },
    },
    detail: {
      helmet: {
        title: 'Impact › {{metricTitle}}',
      },
      columns: {
        hours: 'Hours',
        opportunitiesCompleted: 'Events Completed',
        lastOpportunity: 'Last Event',
        name: 'Name',
        signUps: 'Sign Ups',
        attendanceRate: 'Attendance Rate',
        topCauses: 'Top Causes',
        topNonprofits: 'Top Nonprofits',
        department: 'Department',
        date: 'Date',
        attendance: 'Attendance',
        nonprofit: 'Nonprofit',
        causes: 'Causes',
        topDepartments: 'Top Departments',
      },
      metrics: {
        topLocations: 'Top Locations',
        topDepartments: 'Top Departments',
        topCauses: 'Top Causes',
        topNonprofits: 'Top Nonprofits',
        activeEmployees: 'Most Active Employees',
        recentActivity: 'Most Recent Activity',
        topCausePillars: 'Top Initiatives',
      },
      emptyState: {
        title: 'No Data',
        description:
          "It looks like you don't have any data yet. Consider modifying your filters",
      },
    },
    exportsModal: {
      title: 'Export Settings',
      selectAll: 'Select All',
      clearAll: 'Clear All',
      cta: 'Export',
      description:
        'Personalize the data you would like to include before downloading a CSV with your company’s impact stats',
      groupBy: {
        label: 'Group By',
        description:
          'Your selection will determine whether the exported data shows stats per user or per event.',
        user: 'User',
        event: 'Event',
      },
      filters: {
        noFiltersDesc:
          'You have no added filters. You can always add custom filters by pressing the Filters menu.',
        youHave: 'You have',
        filtersApplied: 'filter(s) applied.',
      },
      columns: {
        label: 'Columns',
        guestsDesc: 'Include hours from volunteers who do not have Purposely accounts',
        hoursDesc:
          'The total number of volunteer hours contributed by that user',
        eventsDesc: 'The total number of events attended by that user',
        attendanceDesc: 'The percentage of events attended by that user',
        locationDesc: 'Where the user is located',
        departmentDesc: 'The user’s department',
        workHoursDesc: 'The total number of VDFC and Care Days hours contributed by that user',
        nonprofitDesc:
          'Each nonprofit that your company has volunteered with will receive its own column and the associated value will represent the total hours/events volunteered per user',
        causesDesc:
          'Each cause that your company has volunteered towards will receive its own column and the associated value will represent the total hours/events volunteered per user',
        fields: {
          guest_hours: 'Guest Hours',
          total_hours: 'Total Hours',
          total_events: 'Total Events',
          attendance_rate: 'Attendance Rate',
          city: 'City',
          region: 'Region',
          country: 'Country',
          department: 'Department',
          vdfc: 'VDFC Hours',
          care_days: 'Care Days Hours',
          hours_per_nonprofit: 'Hours per Nonprofit',
          events_per_nonprofit: 'Events per Nonprofit',
          hours_per_cause: 'Hours per Cause',
          events_per_cause: 'Events per Cause',
        },
      },
    },
  },
}
